module.exports = __webpack_public_path__ + "img/tabbar-icon-integral.e3efb791.png";